<template>
  <ul
    v-if="visible"
    class="context-menu"
    :style="{ top: `${position.y}px`, left: `${position.x}px` }"
  >
    <li
      v-for="(item, index) in menuItems"
      :key="index"
      @mouseover="showSubmenu(item)"
      @mouseleave="hideSubmenu()"
      @click.stop="handleAction(item)"
      class="menu-item"
    >
      {{ item.label }}
      <span v-if="item.children" class="arrow">▶</span>

      <!-- 하위 메뉴 -->
      <ul
        v-if="item === activeSubmenu"
        class="submenu"
        :style="{ top: `${submenuPosition.y}px`, left: `${submenuPosition.x}px` }"
      >
        <li
          v-for="(child, idx) in item.children"
          :key="idx"
          @click.stop="handleAction(child)"
          class="submenu-item"
        >
          {{ child.label }}
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup>
import { ref } from 'vue';
import { visible, position, menuItems, closeMenu } from '@/utils/ContextMenu.js';

// 하위 메뉴 상태 관리
const activeSubmenu = ref(null);
const submenuPosition = ref({ x: 0, y: 0 });

// 메뉴 항목 클릭 처리
function handleAction(item) {
  // action이 없는 경우 메뉴를 닫지 않음
  if (item.action) {
    item.action();
    closeMenu();
  }
}

// 하위 메뉴 표시
function showSubmenu(item) {
  if (item.children) {
    activeSubmenu.value = item;
    
    submenuPosition.value = {
      x: position.right + 5, // 메인 메뉴 항목의 오른쪽에 하위 메뉴 위치
      y: position.top + 50,
    };
  }
}

// 하위 메뉴 숨기기
function hideSubmenu() {
  activeSubmenu.value = null;
}
</script>

<style scoped>
.context-menu {
  position: absolute;
  background: #ffffff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 10px 0;
  margin: 0;
  z-index: 1000;
  font-size: 14px;
  min-width: 100px;
  border-radius: 6px;
  font-family: 'Arial', sans-serif;
  text-align: left;
}

.context-menu .menu-item {
  padding: 8px 20px;
  cursor: pointer;
  position: relative;
  font-weight: 600;
  transition: background-color 0.3s ease;
}

.context-menu .menu-item:hover {
  background-color: #bdbdbd;
}

.context-menu .arrow {
  float: right;
  margin-left: 10px;
  font-size: 12px;
  color: #777;
}

.submenu {
  position: absolute;
  background: #ffffff;
  border: 1px solid #ccc;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 1001;
  font-size: 14px;
  min-width: 100px;
  border-radius: 6px;
  top: 0;
  left: 100%;
  margin-top: 0px; /* 하위 메뉴와 메인 메뉴의 간격을 맞추기 위해 */
  transition: opacity 0.3s ease, transform 0.3s ease; /* 부드러운 전환 */
  opacity: 0; /* 기본 숨김 처리 */
  transform: translateY(-10px); /* 부드러운 애니메이션 */
}

.submenu-item {
  padding: 8px 20px;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.3s ease;
}

.submenu-item:hover {
  background-color: #bdbdbd;
}

/* 활성화된 상태 */
.context-menu .menu-item:hover .submenu {
  opacity: 1;
  transform: translateY(0);
}
</style>
